<div class="row mb-3">
    <div class="col-12 d-flex justify-content-center">
        <div class="w-100" style="max-width: 1400px;">
            <mat-card class="p-3 pb-0 poc-selector-fields">
                <div class="selection-bar">
                    <div class="left">

                        <mat-form-field appearance="outline" class="me-3">
                            <mat-label>{{ dateLabel }}</mat-label>
                            <input matInput [matDatepicker]="picker" [value]="effectiveDate" (dateChange)="onDateChange($event)" [min]="minDate">
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>{{ localeLabel }}</mat-label>
                            <mat-select [value]="locale" (selectionChange)="onLocaleChange($event.value)" [disabled]="true">
                                <mat-option *ngFor="let option of locales"
                                            [value]="option.value"
                                            [disabled]="option.disabled"
                                            [class.fw-bold]="option.bold">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="variation-field">
                            <mat-label>Variation</mat-label>
                            <mat-select [value]="variation"
                                        (selectionChange)="onVariationChange($event.value)">
                                <mat-option *ngFor="let option of variations"
                                            [value]="option.variationTag"
                                            [matTooltip]="option.variationDescription">
                                    {{ option.variationLabel ?? option.variationTag }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <emm-quick-view-button
                            style="position:relative; bottom: 10px"
                            [item]="item"
                            [variations]="variations"
                        ></emm-quick-view-button>
                    </div>

                    <div class="right" *ngIf="showButtons">
                        <button mat-raised-button
                                color="primary"
                                type="button"
                                [disabled]="createDisabled"
                                (click)="onCreateClick()"
                                matTooltip="Create a new variation for {{ item.tag }}"
                                style="margin-left: 8px;">
                            <mat-icon class="me-1">add</mat-icon>
                            Create Variation
                        </button>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</div>
